/* globals jQuery */
import { easing, animSpeed } from './_vars.js';

(function(window, document, $) {
	var scrollPosition;
	var openModal = function (event) {
		var mask = $('<div class="mask" />');
		mask.appendTo('body').fadeTo(animSpeed, 0.6, easing).on('click', closeModal);
		var modalToOpen = event.target.hash;
		$(modalToOpen).find(':input').prop('disabled', false);
		$(modalToOpen).fadeIn(animSpeed, easing);
		scrollPosition = window.pageYOffset;
		$('html').css({
			position: 'fixed',
			width: '100%'
		});
		$('body').css({
			overflow: 'hidden',
			top: -scrollPosition + 'px'
		});
	};

	var preventHash = function (event) {
		event.preventDefault();
	};

	var closeModal = function () {
		$('.mask').remove();
		$('.modal-window').find(':input').prop('disabled', true);
		$('.modal-window').hide();
		$('html').css({
			position: '',
			width: ''
		});
		$('body').css({
			overflow: '',
			top: ''
		});
		window.scrollTo(0, scrollPosition);
	};

	// Disable the modal inputs so they are not submit along with other form submissions
	$(document).on('ready', function () {
		$('.modal-window').find(':input').prop('disabled', true);
	});

	$(document).on('click', '.modal-window .modal-close', function (e) {
		closeModal();
		e.preventDefault();
	});

	// When an error is showing underneath an input and it's focused, the first click blurs the input.
	// This causes a click for this event not to fire. Mouseup (or mousedown) fires whether or not an input is focused.
	$(document).on('mouseup', '.open-modal', openModal);
	$(document).on('click', '.open-modal', preventHash);

	$(document).keydown(function(e) {
		if (e.keyCode === 27) {
			if ($('.modal-window').is(':visible')){
				closeModal();
			}
		}
	});
	$.fn.closeModal = closeModal;
}(window, document, jQuery));